/**
 * Cofre Module Routes — license + purchase account CRUD (Plan 2).
 *
 * Permissions follow the seed in
 * V1/backend/app/db/seeds/cofre_permissions_seed.py:
 * - purchase_accounts:read|create|update
 * - licenses:read|create|update
 *
 * Credentials and revealing flow ship later in Plan 3.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";


const CofreDashboard = lazy(() => import("@/pages/cofre/CofreDashboard"));
const CofreOffboarding = lazy(() => import("@/pages/cofre/CofreOffboarding"));
const PurchaseAccountsList = lazy(
  () => import("@/pages/cofre/PurchaseAccountsList"),
);
const PurchaseAccountForm = lazy(
  () => import("@/pages/cofre/PurchaseAccountForm"),
);
const LicensesList = lazy(() => import("@/pages/cofre/LicensesList"));
const LicenseForm = lazy(() => import("@/pages/cofre/LicenseForm"));
const LicenseBatchesList = lazy(
  () => import("@/pages/cofre/LicenseBatchesList"),
);
const LicenseBatchForm = lazy(
  () => import("@/pages/cofre/LicenseBatchForm"),
);
const SuppliersList = lazy(() => import("@/pages/cofre/SuppliersList"));
const SupplierForm = lazy(() => import("@/pages/cofre/SupplierForm"));
const CredentialsList = lazy(() => import("@/pages/cofre/CredentialsList"));
const CredentialForm = lazy(() => import("@/pages/cofre/CredentialForm"));


export const cofreRoutes: ModuleRoutes = {
  moduleId: "cofre",
  basePath: "/cofre",
  routes: [
    {
      path: "/cofre",
      element: <CofreDashboard />,
      permission: { resource: "licenses", action: "read" },
    },
    {
      path: "/cofre/off-boarding",
      element: <CofreOffboarding />,
      permission: { resource: "credentials", action: "update" },
    },
    {
      path: "/cofre/contas-de-compra",
      element: <PurchaseAccountsList />,
      permission: { resource: "purchase_accounts", action: "read" },
    },
    {
      path: "/cofre/contas-de-compra/nova",
      element: <PurchaseAccountForm />,
      permission: { resource: "purchase_accounts", action: "create" },
    },
    {
      path: "/cofre/contas-de-compra/:id",
      element: <PurchaseAccountForm />,
      permission: { resource: "purchase_accounts", action: "read" },
    },
    {
      path: "/cofre/licencas",
      element: <LicensesList />,
      permission: { resource: "licenses", action: "read" },
    },
    {
      path: "/cofre/licencas/nova",
      element: <LicenseForm />,
      permission: { resource: "licenses", action: "create" },
    },
    {
      path: "/cofre/licencas/:id",
      element: <LicenseForm />,
      permission: { resource: "licenses", action: "read" },
    },
    {
      path: "/cofre/lotes",
      element: <LicenseBatchesList />,
      permission: { resource: "licenses", action: "read" },
    },
    {
      path: "/cofre/lotes/novo",
      element: <LicenseBatchForm />,
      permission: { resource: "licenses", action: "create" },
    },
    {
      path: "/cofre/lotes/:id",
      element: <LicenseBatchForm />,
      permission: { resource: "licenses", action: "read" },
    },
    {
      path: "/cofre/fornecedores",
      element: <SuppliersList />,
      permission: { resource: "suppliers", action: "read" },
    },
    {
      path: "/cofre/fornecedores/novo",
      element: <SupplierForm />,
      permission: { resource: "suppliers", action: "create" },
    },
    {
      path: "/cofre/fornecedores/:id",
      element: <SupplierForm />,
      permission: { resource: "suppliers", action: "read" },
    },
    {
      path: "/cofre/credenciais",
      element: <CredentialsList />,
      permission: { resource: "credentials", action: "read" },
    },
    {
      path: "/cofre/credenciais/nova",
      element: <CredentialForm />,
      permission: { resource: "credentials", action: "create" },
    },
    {
      path: "/cofre/credenciais/:id",
      element: <CredentialForm />,
      permission: { resource: "credentials", action: "read" },
    },
  ],
};
